import {
  HostListener,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Component } from '@angular/core';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { UserApiService } from '../../services/user-api.service';
import { LoggerService } from 'src/app/services/logger.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { TabelPaging } from '../../interfaces/table';
import { DatePipe } from '@angular/common';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { Drug, DrugBackEndModel, DrugCode } from '../../models/drug';
import { Dropdown } from 'src/app/models/dropdown';
import { ModalConfirm } from '../../models/modal-confirm';
import { DropDownPagingInput } from 'src/app/models/drop-down-paging-input';
import * as _ from 'lodash-es';
import { ProductType } from 'src/app/enum/product-type';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PCTableComponent } from '../pctable/pctable.component';
import { PcsettingModalComponent } from '../pcsetting-modal/pcsetting-modal.component';

@Component({
  selector: 'app-salamat-product',
  templateUrl: './salamat-product.component.html',
  styleUrls: ['./salamat-product.component.css'],
})
export class SalamatProductComponent implements OnInit {
  constructor(
    private modalService: NgbModal,
    private logger: LoggerService,
    private renderer: Renderer2,
    public datepipe: DatePipe,
    private responseService: CustomizeResponseService,
    private apiService: UserApiService
  ) {
    this.endPoint = 'Essential';
    this.pageName = 'Essential';
    this.thisBarcodeValue = new DrugCode();
    this.productType = ProductType.Essentials;

    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == '+') {
        this.OpenAddModal();
      }
    });

    this.requestModel = new PCSearchRequestModel();

    this.action = new PCTableActionInputModel(
      [
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Create',
          className: 'btn-outline-primary',
          icon: 'bx bx-plus',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
      ],
      '',
      []
    );

    this.drugFormDropDown.hasRefreshButton = true;
    this.drugUsageDropDown.hasRefreshButton = true;
    this.companyDropDown.hasRefreshButton = true;
    this.creatCompanyDropDown.hasRefreshButton = true;
    this.countryDropDown.hasRefreshButton = true;
    this.keepingTypeDropDown.hasRefreshButton = true;
  }

  @Input() endPoint: string;
  @Input() pageName: string;
  @Input() productType: ProductType;

  public OpenSettingModal: boolean = true;

  public data?: PCTableInputModel;
  public paging?: TabelPaging;
  public action: PCTableActionInputModel;
  public fields: any[] = [];
  public modalDeleteConfirm: boolean = false;
  public modalSuccessConfirm: boolean = false;
  public breadCrumb: string = '';

  public requestModel: PCSearchRequestModel;
  public endPointUrl!: string;
  public loading: boolean = false;
  public loadingModal: boolean = false;
  public thisValue?: Drug;
  public thisBarcodeValue: DrugCode;
  public activeAddModal: boolean = false;
  public modalIsOpen: boolean = false;

  public modalConfirm: ModalConfirm = new ModalConfirm();

  @ViewChild('ModalContent') modalContent!: any;
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;
  @ViewChild('settingsModal') settingsModal!: any;

  public backEndJson: any;

  public genericDropDown: DropDownPagingInput = new DropDownPagingInput(
    'DrugGeneric',
    'title',
    'title',
    false,
    true,
    true,
    true,
    false
  );

  public drugFormDropDown: DropDownPagingInput = new DropDownPagingInput(
    'DrugForm',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );

  public drugUsageDropDown: DropDownPagingInput = new DropDownPagingInput(
    'DrugUsage',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );

  public companyDropDown: DropDownPagingInput = new DropDownPagingInput(
    'Company',
    'name',
    'name',
    false,
    false,
    true,
    true,
    false
  );

  public creatCompanyDropDown: DropDownPagingInput = new DropDownPagingInput(
    'Company',
    'name',
    'name',
    false,
    false,
    true,
    true,
    false
  );

  public countryDropDown: DropDownPagingInput = new DropDownPagingInput(
    'Country',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );

  public keepingTypeDropDown: DropDownPagingInput = new DropDownPagingInput(
    'keepingType',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );

  public ngOnInit(): void {
    try {
    } catch (error) {
      this.logger.addClientException(error, 'ngOnInit');
    }
    if (this.endPoint == null) {
      this.logger.addError('Endpoint is required .....!!!', false);
      return;
    }

    this.action.title = this.endPoint;
    this.generateUrl();

    forkJoin([this.getData(), this.getEntity()]).subscribe(
      ([dataResult, entityResult]) => {
        if (dataResult) {
          this.logger.addResponseLog(this.endPointUrl, dataResult, `Get All`);
          if (dataResult.succeeded) {
            let firstItemOnPage = 1;
            if (dataResult.data?.firstItemOnPage) {
              firstItemOnPage = dataResult.data?.firstItemOnPage;
            }

            if (dataResult.data?.pageCount! < dataResult.data?.pageNumber! && dataResult.data?.pageCount!=0) {
              this.requestModel.pageNumber = 1;
              this.getSingleData();
            }
            this.data = new PCTableInputModel(
              dataResult.data?.items,
              [
                {
                  name: 'Edit',
                  className: 'btn-outline-primary',
                  icon: 'far fa-edit',
                },
                {
                  name: 'Delete',
                  className: 'btn-outline-danger',
                  icon: 'bx bx-trash',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(dataResult);
          } else {
            this.logger.addBackEndMessage(dataResult);
          }
          this.loading = false;
        }

        if (entityResult) {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            entityResult,
            `Get Entity`
          );
          if (entityResult.succeeded) {
            this.fields = this.apiService.convertStringToBoolean(
              entityResult.data.fields
            );

            this.fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            // this.breadCrumb = result.data.items[0].breadCrumb.replace(
            //   'Drug',
            //   this.pageName
            // );

            // var foundedRelationalItem = this.fields.filter(
            //   (current) =>
            //     current.persianName == 'Relational' &&
            //     current.fieldDatatype != 'Guid'
            // );

            // if (result.data.count == 0) {
            //   this.logger.addError('Count is Zero .....!!!', false);
            // }
          } else {
            this.logger.addBackEndMessage(entityResult);
          }
        }

        setTimeout(() => {
          if (this.pcTableComponent) {
            this.pcTableComponent.InitPage();
          } else {
            console.error('PCTableComponent not found');
          }
        }, 2);
        this.loading = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
      }
    );
  }

  public getData() {
    return this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
        return of(null);
      })
    );
  }

  public getSingleData() {
    try {
      this.loading = true;
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
            let firstItemOnPage = result.data?.firstItemOnPage || 1;

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
              this.getSingleData();
            }
            this.data = new PCTableInputModel(
              result.data?.items,
              [
                {
                  name: 'Edit',
                  className: 'btn-outline-primary',
                  icon: 'far fa-edit',
                },
                {
                  name: 'Delete',
                  className: 'btn-outline-danger',
                  icon: 'bx bx-trash',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            const matTable = document.querySelector('.table-responsive');
            if (matTable != null) {
              matTable.scrollTop = 0;
            }

            this.paging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getEntity() {
    return this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          `Drug`
        )
      )
      .pipe(
        catchError((error) => {
          this.apiService.AddErrorLog(error);
          return of(null);
        })
      );
  }

  public generateUrl() {
    this.endPointUrl = `${this.endPoint}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
  }

  public clearForm(inputElement: any) {
    try {
      for (let element of inputElement) {
        element.defValue = null;
      }
    } catch (error) {
      this.logger.addError(error, false);
    }
  }

  public clearEditItem() {
    this.thisValue = new Drug();
    this.genericDropDown.buttonClass = undefined;
    this.drugFormDropDown.buttonClass = undefined;
    this.creatCompanyDropDown.buttonClass = undefined;
    this.drugFormDropDown.defaultValue = 'قرص';
    this.drugFormDropDown.defaultKey = 'a0d45e47-2dd7-42cf-a1d2-63dc2c1468c6';

    this.creatCompanyDropDown.defaultValue = undefined;
    this.creatCompanyDropDown.defaultKey = undefined;

    this.companyDropDown.defaultValue = undefined;
    this.companyDropDown.defaultKey = undefined;

    this.drugUsageDropDown.defaultValue = 'خوراکی';
    this.drugUsageDropDown.defaultKey = '25db3f75-d6e1-4bc2-bea5-2c990da90d9d';

    this.countryDropDown.defaultValue = 'ایران';
    this.countryDropDown.defaultKey = 'BBCEFAFD-88DD-4DF5-AA3F-763899168559';

    this.keepingTypeDropDown.defaultValue = 'دور از گرما و نور مستقیم خورشید';
    this.keepingTypeDropDown.defaultKey =
      '91d5519f-075d-46c2-bc46-f0aba2254f97';

    this.genericDropDown.defaultValue = undefined;
    this.genericDropDown.defaultKey = undefined;
  }

  public submitDelete() {
    try {
      if (this.thisValue == null) {
        return;
      }
      this.loading = true;
      let url = `${this.endPoint}/${this.thisValue.id}`;

      this.apiService.deleteItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Delete`);
          if (result.succeeded) {
            this.getSingleData();
            this.modalSuccessConfirm = true;
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, false);
    }
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        }

        this.requestModel.orderBy = event.data;

        this.generateUrl();
        this.getSingleData();
        break;
      case 'Search':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Paging':
        this.loading = true;
        this.requestModel.pageNumber = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'PageSize':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Reload':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Create':
        this.OpenAddModal();
        break;
      case 'SaveAdd':
        this.saveAdd();
        break;
      case 'Edit':
        this.OpenEditModal(event.data);
        break;
      case 'SaveEdit':
        this.saveEdit();
        break;
      case 'Close':
        //TODO
        break;
      case 'Delete':
        this.modalDeleteConfirm = true;
        this.thisValue = event.data;
        break;
      case 'NotDelete':
        this.modalDeleteConfirm = false;
        this.thisValue = undefined;
        break;
      case 'ConfirmDelete':
        this.modalDeleteConfirm = false;
        this.submitDelete();
        break;
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
      case 'Settings':
        this.pcsettingModalComponent.openSettingModal();
        break;
      case 'SubmitSetting':
        this.fields = event.data;
        if (this.pcTableComponent) {
          this.pcTableComponent.RebuildColumn();
        } else {
          console.error('PCTableComponent not found');
        }
        break;

      case 'CloseModal':
        this.modalService.dismissAll();
        break;

      case 'UpdateSuccess':
        this.modalService.dismissAll();
        this.modalSuccessConfirm = true;
        this.getSingleData();
        break;
      default:
        break;
    }
  }

  public changeTime(value: any): string | null {
    var timeArray = value.split(':');
    var date = new Date();
    date.setHours(timeArray[0]);
    date.setMinutes(timeArray[1]);
    date.setSeconds(0);

    return this.datepipe.transform(date, 'HH:mm:ss');
  }

  public OpenEditModal(item: Drug) {
    if (this.modalIsOpen) {
      return;
    }
    this.activeAddModal = false;
    this.clearEditItem();
    this.thisValue = _.cloneDeep(item);

    if (this.thisValue?.drugCodes == null) {
      this.thisValue!.drugCodes = [];
    }

    this.drugFormDropDown.defaultValue = item.drugFormName;
    this.drugFormDropDown.defaultKey = item.drugFormId;

    this.creatCompanyDropDown.defaultValue = item.creatorCompanyName;
    this.creatCompanyDropDown.defaultKey = item.creatorCompanyId;

    this.companyDropDown.defaultValue = item.licenseCompanyName;
    this.companyDropDown.defaultKey = item.licenseCompanyId;

    this.drugUsageDropDown.defaultValue = item.drugUsageName;
    this.drugUsageDropDown.defaultKey = item.drugUsageId;

    this.countryDropDown.defaultValue = item.countryName;
    this.countryDropDown.defaultKey = item.countryId;

    this.keepingTypeDropDown.defaultValue = item.keepingTypeName;
    this.keepingTypeDropDown.defaultKey = item.keepingTypeId;

    this.genericDropDown.defaultValue = item.drugGenericName;
    this.genericDropDown.defaultKey = item.drugGenericId;

    setTimeout(() => {
      this.openModal();
    }, 2);
  }

  public OpenAddModal() {
    if (this.modalIsOpen) {
      return;
    }

    this.activeAddModal = true;
    this.clearEditItem();
    this.openModal();
  }

  private openModal() {
    try {
      this.modalIsOpen = true;
      this.modalService
        .open(this.modalContent, {
          size: 'xl',
          ariaLabelledBy: 'modal-basic-title',
        })
        .result.then(
          (result) => {
            this.modalIsOpen = false;
            if (result == 'Save click') {
              //this.callParent('Save', this.thisValue);
            }

            //this.callParent('Close', null);
          },
          (reason) => {
            this.modalIsOpen = false;
            //this.callParent('Close', null);
          }
        );
    } catch (error) {
      this.modalIsOpen = false;
      this.logger.addException(error, false);
    }
  }

  public submit() {
    if (this.activeAddModal) {
      this.saveAdd();
    } else {
      this.saveEdit();
    }
  }

  private toJSON(): DrugBackEndModel {
    if (this.thisValue == null) {
      return new DrugBackEndModel();
    }

    return {
      name: this.thisValue.name,
      persianName: this.thisValue.persianName,
      attachment: this.thisValue.attachment,
      sellPrice: this.thisValue.sellPrice,
      buyPrice: this.thisValue.buyPrice,
      flavor: this.thisValue.flavor,
      drugGenericId: this.thisValue.drugGenericId,
      drugFormId: this.thisValue.drugFormId,
      drugUsageId: this.thisValue.drugUsageId,
      creatorCompanyId: this.thisValue.creatorCompanyId,
      countryId: this.thisValue.countryId,
      drugPackageCount: this.thisValue.drugPackageCount,
      keepingTypeId: this.thisValue.keepingTypeId,
      licenseCompanyId: this.thisValue.licenseCompanyId,
      productTypeEnum: this.productType,
    };
  }

  public saveAdd() {
    try {
      if (!this.checkValidation()) {
        return;
      }

      this.loadingModal = true;
      let url = `${this.endPoint}`;

      const backendJson = this.toJSON();

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (
            this.thisValue?.drugCodes != null &&
            this.thisValue.drugCodes.length > 0
          ) {
            this.addDrugCodeList(result.data.id);
            return;
          }

          this.completeSuccess();
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingModal = false;
        },
        () => {
          this.loadingModal = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingModal = false;
    }
  }

  public completeSuccess() {
    this.getSingleData();
    this.modalSuccessConfirm = true;
    this.modalService.dismissAll();
    this.loadingModal = false;
  }

  public saveEdit() {
    try {
      if (!this.checkValidation()) {
        return;
      }

      this.loadingModal = true;

      let url = `${this.endPoint}/${this.thisValue!.id}`;

      const backendJson = this.toJSON();

      this.apiService
        .patchItem(new ApiRequestModel(url, backendJson))
        .subscribe(
          (result) => {
            this.completeSuccess();
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loadingModal = false;
          },
          () => {
            this.loadingModal = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public addDrugCodeList(drugId: string) {
    try {
      this.loadingModal = true;

      if (this.thisValue == null) {
        return;
      }
      let url = `DrugCode/List`;

      const thisDrugCodeList: any[] = this.thisValue.drugCodes.map(
        (current) => ({
          erxCode: current.erxCode,
          irc: current.irc,
          gtn: current.gtn,
          barCode: current.barCode,
          drugId: drugId,
        })
      );

      console.log(thisDrugCodeList);

      this.apiService
        .postItem(new ApiRequestModel(url, thisDrugCodeList))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.completeSuccess();
            } else {
              this.apiService.AddErrorLog(result);
            }
            this.loadingModal = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loadingModal = false;
          },
          () => {
            this.loadingModal = false;
          }
        );
    } catch (error) {
      this.logger.addClientException(error, 'saveDrugCode');
    }
  }

  public addDrugCode() {
    try {
      this.loadingModal = true;

      if (this.thisValue == null || !this.checkDrugCodeValidation()) {
        return;
      }
      let url = `DrugCode`;

      this.apiService
        .postItem(new ApiRequestModel(url, this.thisBarcodeValue))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              if (this.thisValue != null) {
                this.thisValue.drugCodes.push(result.data);
                this.thisBarcodeValue = new DrugCode();
              }
            } else {
              this.apiService.AddErrorLog(result);
            }
            this.loadingModal = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loadingModal = false;
          },
          () => {
            this.loadingModal = false;
          }
        );
    } catch (error) {
      this.logger.addClientException(error, 'saveDrugCode');
    }
  }

  public editDrugCode(item: DrugCode, index: number) {
    try {
      if (this.thisValue?.id == null) {
        return;
      }
      item.drugId = this.thisValue.id;

      this.thisBarcodeValue = _.cloneDeep(item);

      if (this.thisBarcodeValue.id == null) {
        this.thisBarcodeValue.id = index.toString();
      }
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public saveEditDrugCode() {
    try {
      if (
        this.thisBarcodeValue == null ||
        this.thisBarcodeValue.id == null ||
        !this.checkDrugCodeValidation()
      ) {
        return;
      }

      this.loadingModal = true;

      const thisValue = _.cloneDeep(this.thisBarcodeValue);

      let url = `DrugCode/${this.thisBarcodeValue.id}`;

      this.apiService.patchItem(new ApiRequestModel(url, thisValue)).subscribe(
        (result) => {
          if (result.succeeded && this.thisValue != null) {
            const index = this.thisValue.drugCodes.findIndex(
              (current) => current.id == result.data.id
            );

            this.thisValue.drugCodes[index] = result.data;
            this.thisBarcodeValue = new DrugCode();
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingModal = false;
        },
        () => {
          this.loadingModal = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public checkValidation(): boolean {
    const requiredMessage = 'وارد کردن این فیلد اجباری می باشد';
    const minLengthMessage = 'مقدار این فیلد نمیتواند کمتر از 3 کاراکتر باشد';
    let isSucceed = true;

    if (this.thisValue == null) {
      return false;
    }

    if (this.thisValue.name == null || this.thisValue.name == '') {
      this.thisValue.nameHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.name.length < 3) {
      this.thisValue.nameHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.nameHint = undefined;
    }

    if (
      this.thisValue.persianName == null ||
      this.thisValue.persianName == ''
    ) {
      this.thisValue.persianNameHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.persianName.length < 3) {
      this.thisValue.persianNameHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.persianNameHint = undefined;
    }

    // if (this.thisValue.erxCode == null || this.thisValue.erxCode == '') {
    //   this.thisValue.erxCodeHint = requiredMessage;
    //   this.publicInformationError = true;
    // } else if (this.thisValue.erxCode.length < 3) {
    //   this.thisValue.erxCodeHint = minLengthMessage;
    //   this.publicInformationError = true;
    // } else {
    //   this.thisValue.erxCodeHint = undefined;
    // }

    // if (this.thisValue.irc == null || this.thisValue.irc == '') {
    //   this.thisValue.ircHint = requiredMessage;
    //   this.publicInformationError = true;
    // } else if (this.thisValue.irc.length < 3) {
    //   this.thisValue.ircHint = minLengthMessage;
    //   this.publicInformationError = true;
    // } else {
    //   this.thisValue.ircHint = undefined;
    // }

    // if (this.thisValue.gtn == null || this.thisValue.gtn == '') {
    //   this.thisValue.gtnHint = requiredMessage;
    //   this.publicInformationError = true;
    // } else if (this.thisValue.gtn.length < 3) {
    //   this.thisValue.gtnHint = minLengthMessage;
    //   this.publicInformationError = true;
    // } else {
    //   this.thisValue.gtnHint = undefined;
    // }

    if (this.pageName == 'Drug') {
      if (
        this.thisValue.drugGenericId == null ||
        this.thisValue.drugGenericId == ''
      ) {
        this.genericDropDown.buttonClass = 'is-invalid';
        this.thisValue.drugGenericHint = requiredMessage;
        isSucceed = false;
      } else {
        this.thisValue.drugGenericHint = undefined;
        this.drugFormDropDown.buttonClass = '';
      }
    } else {
      this.thisValue.drugGenericId = '00000000-0000-0000-0000-000000000000';
    }

    if (
      this.thisValue.drugFormId == null ||
      this.thisValue.drugFormId == '00000000-0000-0000-0000-000000000000' ||
      this.thisValue.drugFormId == ''
    ) {
      this.drugFormDropDown.buttonClass = 'is-invalid';
      this.thisValue.drugFormHint = requiredMessage;
      isSucceed = false;
    } else {
      this.thisValue.drugFormHint = undefined;
      this.drugFormDropDown.buttonClass = '';
    }

    // if (
    //   this.thisValue.drugUsageId == null ||
    //   this.thisValue.drugUsageId == ''
    // ) {
    //   this.thisValue.drugUsageHint = requiredMessage;
    //   isSucceed = false;
    // } else {
    //   this.thisValue.drugUsageHint = undefined;
    // }

    if (
      this.thisValue.creatorCompanyId == null ||
      this.thisValue.creatorCompanyId ==
      '00000000-0000-0000-0000-000000000000' ||
      this.thisValue.creatorCompanyId == ''
    ) {
      this.creatCompanyDropDown.buttonClass = 'is-invalid';
      this.thisValue.creatorCompanyHint = requiredMessage;
      isSucceed = false;
    } else {
      this.thisValue.creatorCompanyHint = undefined;
      this.drugFormDropDown.buttonClass = '';
    }

    // if (
    //   this.thisValue.licenseCompanyId == null ||
    //   this.thisValue.licenseCompanyId == ''
    // ) {
    //   this.thisValue.licenseCompanyHint = requiredMessage;
    //   isSucceed = false;
    // } else {
    //   this.thisValue.licenseCompanyHint = undefined;
    // }

    // if (this.thisValue.countryId == null || this.thisValue.countryId == '') {
    //   this.thisValue.countryHint = requiredMessage;
    //   isSucceed = false;
    // } else {
    //   this.thisValue.countryHint = undefined;
    // }

    if (
      this.thisValue.drugPackageCount == null ||
      this.thisValue.drugPackageCount.toString() == '' ||
      this.thisValue.drugPackageCount == 0
    ) {
      this.thisValue.drugPackageHint = requiredMessage;
      isSucceed = false;
    } else {
      this.thisValue.drugPackageHint = undefined;
    }

    // if (
    //   this.thisValue.keepingTypeId == null ||
    //   this.thisValue.keepingTypeId == ''
    // ) {
    //   this.thisValue.keepingTypeHint = requiredMessage;
    //   isSucceed = false;
    // } else {
    //   this.thisValue.keepingTypeHint = undefined;
    // }

    if (this.thisValue.buyPrice == null || this.thisValue.buyPrice == 0) {
      this.thisValue.buyPriceHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.buyPrice < 500) {
      this.thisValue.buyPriceHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.buyPriceHint = undefined;
    }

    if (this.thisValue.sellPrice == null || this.thisValue.sellPrice == 0) {
      this.thisValue.costHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.sellPrice < 500) {
      this.thisValue.costHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.costHint = undefined;
    }

    return isSucceed;
  }

  public checkDrugCodeValidation(): boolean {
    if (this.thisBarcodeValue == null || this.thisValue == null) {
      return false;
    }

    if (
      this.thisBarcodeValue.gtn == null &&
      this.thisBarcodeValue.erxCode == null &&
      this.thisBarcodeValue.irc == null &&
      this.thisBarcodeValue.barCode == null
    ) {
      return false;
    }
    return true;
  }

  public addNewDrugCode(drugId?: string) {
    if (this.thisValue == null || !this.checkDrugCodeValidation()) {
      return;
    }

    if (drugId == null || drugId == '') {
      if (this.thisBarcodeValue.id == null) {
        const thisValue = _.cloneDeep(this.thisBarcodeValue);
        this.thisValue.drugCodes.push(thisValue);
        this.thisBarcodeValue = new DrugCode();
      } else {
        const index = _.cloneDeep(this.thisBarcodeValue.id);
        this.thisBarcodeValue.id = undefined;
        this.thisValue.drugCodes[index] = this.thisBarcodeValue;
        this.thisBarcodeValue = new DrugCode();
      }
    } else {
      this.thisBarcodeValue.drugId = drugId;
      if (this.thisBarcodeValue.id == null) {
        this.addDrugCode();
      } else {
        this.saveEditDrugCode();
      }
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      const target = event.target as HTMLElement;
      if (target.classList.contains('go-to-next')) {
        this.handleEnterKey(event);
      }
    }
    if (event.key === 'ArrowDown') {
      const target = event.target as HTMLElement;

      if (target && typeof target.click === 'function') {
        target.click();
      }
    }
  }

  handleEnterKey(event: KeyboardEvent) {
    const activeElement = document.activeElement;
    event.preventDefault();
    this.moveFocusToNextElement(activeElement as HTMLElement);
  }

  moveFocusToNextElement(currentElement: HTMLElement) {
    const focusableElements = Array.from(
      document.querySelectorAll(
        'input, button, [tabindex]:not([tabindex="-1"])'
      )
    ) as HTMLElement[];
    const currentIndex = focusableElements.indexOf(currentElement);
    const nextIndex = (currentIndex + 1) % focusableElements.length;
    focusableElements[nextIndex].focus();
  }
}
